export default __webpack_public_path__ + "static/Organisational change projects-d9d00629df31b9175993dd28fdf90117.jpg";